import { all, call, put } from 'redux-saga/effects';
import { FETCH_PROFILE_FAILED, FETCH_PROFILE_SUCCESS, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILED, CITY_FOR_ZIP_CODE_FAILED, CITY_FOR_ZIP_CODE_SUCCESS } from '../actions/types';
import { getProfileService, profileUpdateService, cityForZipCodeService } from '../services/profile';

export function* fetchProfile() {
  try {
    const result = yield call(getProfileService);
    yield put({ type: FETCH_PROFILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FETCH_PROFILE_FAILED, data: error.response.data.message });
  }
}

export function* editProfile(action) {
  try {
    const result = yield call(profileUpdateService, action.payload);
    yield put({ type: EDIT_PROFILE_SUCCESS, data: result.users });
  } catch (error) {
    yield put({ type: EDIT_PROFILE_FAILED, data: error.response.data.message });
  }
}

export function* cityForZipCode(action) {
  try {
    const result = yield call(cityForZipCodeService, action.payload);
    yield put({ type: CITY_FOR_ZIP_CODE_SUCCESS, data: result.postalcodes });
  } catch (error) {
    yield put({ type: CITY_FOR_ZIP_CODE_FAILED, data: error.response.data.message });
  }
}
